const logos = ["FirstSource", "Q Agency", "Airtel", "Tech Jini", "INRY", "SunTec", "Team Viewer", "Hilton"];

export function LogoSlider() {
  return (
    <div className="relative overflow-hidden py-8">
      {/* Gradient overlays */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-background to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-background to-transparent z-10" />

      {/* CSS-based infinite scroll for better performance */}
      <div className="flex gap-12 items-center animate-scroll-x">
        {/* Double the logos for seamless loop */}
        {[...logos, ...logos, ...logos].map((logo, i) => (
          <div
            key={i}
            className="flex-shrink-0 text-xl md:text-2xl font-semibold text-muted-foreground/50 hover:text-muted-foreground transition-colors whitespace-nowrap"
          >
            {logo}
          </div>
        ))}
      </div>
    </div>
  );
}
